module.exports = __webpack_public_path__ + "img/kp.ca4bfa12.jpg";